<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 15 19" fill="none">
    <path
      d="M13.9902 3.89648L10.3572 0.259766C10.1902 0.0927734 9.96387 0 9.72637 0H9.5V4.75H14.25V4.52363C14.25 4.28984 14.1572 4.06348 13.9902 3.89648ZM8.3125 5.04688V0H0.890625C0.39707 0 0 0.39707 0 0.890625V18.1094C0 18.6029 0.39707 19 0.890625 19H13.3594C13.8529 19 14.25 18.6029 14.25 18.1094V5.9375H9.20313C8.71328 5.9375 8.3125 5.53672 8.3125 5.04688Z"
      :fill="color"/>
    <path d="M5.16666 10.5L6.91666 12.25L9.83332 8.75" stroke="#F2F2F2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: "IconsFinanceReport",
  props: {
    width: {
      type: [Number, String],
      default: 21
    },
    height: {
      type: [Number, String],
      default: 28
    },
    color: {
      type: String,
      default: '#219653'
    },
    icon: String,
  }
}
</script>

<style scoped>

</style>
